import {createTheme, responsiveFontSizes, ThemeOptions} from "@mui/material/styles";

const themeOpts : ThemeOptions = {
    spacing: 8,
    palette: {
        // Old primary
        // primary: {
        //     main: '#007155',
        //     light: '#66AC47',
        //     dark: '#01533F'
        // },
        // secondary: {
        //     main: '#FFD416',
        //     dark: '#D99B13'
        // },
        // TODO: Add more new UVM colors (if they exist, I think there's like 6 of them?)
        primary: {
            main: '#154734',
            light: '#66AC47',
            dark: '#00313C'
        },
        secondary: {
            main: '#FFD100',
            dark: '#D99B13'
        },
        // Error is still the same for now, could do the 'Old Mill' color? (#DC582A)
        error: {
            main: '#8A0C1A',
            light: '#F47D20'
        }
    },
    //TODO: Fix font weight issue - try importing Montserrat at different weights?
    typography: {
        fontFamily: 'Raleway',
        fontSize: 15,
        allVariants: {
            fontWeight: 400
        }
    },
    components: {
        MuiFormLabel: {
            defaultProps: {
                sx: {
                    fontSize: "15px",
                    top: 2,
                },
            },
        },
        MuiSnackbar: {
            defaultProps: {
                autoHideDuration:5000
            }
        }
    }
}
let theme = createTheme(themeOpts)
theme = responsiveFontSizes(theme)
export default theme
